import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as pageAction from './../../../../actions/pageAction';
import Pages from './Pages';

const mapStateToProps = state => {
    return {
        pageState: state.pageReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListPages: (filters) => dispatch(pageAction.getListPages(filters)),
        deletePageDetail: (page, filters) => dispatch(pageAction.deletePageDetail(page, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Pages));
